import { MutationTree } from 'vuex'

import { LogState } from '@/types/store'
import { ILog, IProgresses } from '@/types/log'

export const mutations: MutationTree<LogState> = {
  setIsLogsLoading(state, isLogsLoading: boolean) {
    state.isLogsLoading = isLogsLoading
  },
  logsLoaded(state, logs: ILog[]) {
    state.logs = logs
  },
  setIsProgressesLoading(state, isProgressesLoading: boolean) {
    state.isProgressesLoading = isProgressesLoading
  },
  progressesLoaded(state, progresses: IProgresses) {
    state.progresses = progresses
  },
  newProgressesLoaded(state, progresses: IProgresses) {
    state.progresses = {
      ...state.progresses,
      checked: {
        ...state.progresses.checked,
        monthly: progresses.checked.monthly,
        today: progresses.checked.today,
      },
      ng: {
        ...state.progresses.ng,
        monthly: progresses.ng.monthly,
        today: progresses.ng.today,
      },
      createdItem: {
        ...state.progresses.createdItem,
        monthly: progresses.createdItem.monthly,
        today: progresses.createdItem.today,
      },
    }
    if (
      state.progresses.uncheckedSystemNgToLeaderOk &&
      progresses.uncheckedSystemNgToLeaderOk
    ) {
      state.progresses = {
        ...state.progresses,
        uncheckedSystemNgToLeaderOk: {
          ...state.progresses.uncheckedSystemNgToLeaderOk,
          monthly: progresses.uncheckedSystemNgToLeaderOk.monthly,
          today: progresses.uncheckedSystemNgToLeaderOk.today,
        },
      }
    }
    if (
      state.progresses.uncheckedSystemNgToLeaderNg &&
      progresses.uncheckedSystemNgToLeaderNg
    ) {
      state.progresses = {
        ...state.progresses,
        uncheckedSystemNgToLeaderNg: {
          ...state.progresses.uncheckedSystemNgToLeaderNg,
          monthly: progresses.uncheckedSystemNgToLeaderNg.monthly,
          today: progresses.uncheckedSystemNgToLeaderNg.today,
        },
      }
    }
    if (state.progresses.linkerNgToLeaderOk && progresses.linkerNgToLeaderOk) {
      state.progresses = {
        ...state.progresses,
        linkerNgToLeaderOk: {
          ...state.progresses.linkerNgToLeaderOk,
          monthly: progresses.linkerNgToLeaderOk.monthly,
          today: progresses.linkerNgToLeaderOk.today,
        },
      }
    }
    if (state.progresses.linkerNgToLeaderNg && progresses.linkerNgToLeaderNg) {
      state.progresses = {
        ...state.progresses,
        linkerNgToLeaderNg: {
          ...state.progresses.linkerNgToLeaderNg,
          monthly: progresses.linkerNgToLeaderNg.monthly,
          today: progresses.linkerNgToLeaderNg.today,
        },
      }
    }
  },
}
